export default __webpack_public_path__ + "static/media/1737.0718dbef.png";